<script>
  import { createEventDispatcher } from 'svelte';
  import Button from './Button.svelte';
  import { getTrad,language } from './js/AppState';
  import DataLoading from './js/DataLoading';
  import SGMSApi from './js/SGMSApi';
  const dispatch = createEventDispatcher();


  function onclick(e) {
    SGMSApi.sendActionEvent(e, "SelectLanguage." + $language)
    dispatch('next')
  }
</script>


<div id="language-selector">

  <div class="title">{$getTrad("intro_title")}</div>
  <div class="catchphrase">{$getTrad("app_title")}</div>

  <div class="label">{$getTrad("intro_content")}</div>
  <select bind:value={$language}>
    {#each DataLoading.languages as l}
      <option  value={l.id}>{l.long}</option>
    {/each}
  </select>

  <div class="button">
    <Button name="SelectLanguageButton" on:click={onclick}>{$getTrad("next_btn")}</Button>
  </div>
</div>

<style>
  #language-selector {
    max-width: 600px;
    margin-right: 10px;
  }
  .title {
    color: #00A7E6;
    text-transform: uppercase;
    font-size: 16px;
  }

  .catchphrase {
    text-transform: uppercase;

    margin: 20px 0;

  }

  .label {
    display: block;
    color: #00A7E6;
  }

  select {
    background: transparent;
    text-transform: uppercase;
    border: 1px solid #000;
    outline: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    padding: .6em 1.4em .5em .8em;
    line-height: 1.3;

    background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');
    background-repeat: no-repeat, repeat;
    background-position: right .7em top 50%, 0 0;
    background-size: .65em auto, 100%;
    padding: 15px;
    padding-right: 40px;

    margin-top: 10px;
  }
  option {
    background: transparent;
    padding: 10px;
  }

  /* .button {
    display: inline-block;
    width: 50px;
  } */

  @media screen and (max-width: 800px) {
    select { margin-top: 10px; width: 100%; margin-right: 10px;}
  }

</style>
